module.exports = __webpack_public_path__ + "static/media/1159.1dac6b12.jpg";